import { initCss } from './css';
import { initPolyFill } from './polyfill';
import { initDayJs } from './time';

export const bootstrap = () => {
	initPolyFill();
	initDayJs();
	initCss();

	window.version = A1_VERSION;
};
